<template>
  <ModalLayout icon="request-in-circle" :title="`Request ${meta?.flight ? 'flight' : 'campaign'} revision?`" @close="close">
    <p class="mb-3.5">
      You are requesting revisions for '<strong>{{ name }}</strong
      >'. Please provide detailed instructions for the changes needed.
    </p>

    <!-- Form wrapper -->
    <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
      <!-- Label and Textarea -->
      <el-form-item label="Revision Instructions" prop="instructions" required>
        <el-input
          v-model="form.instructions"
          type="textarea"
          :rows="4"
          :maxlength="400"
          show-word-limit
          placeholder="Please describe the changes required"
        />
      </el-form-item>
    </el-form>

    <!-- Footer buttons -->
    <template #footer>
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" icon="el-icon-top-left" type="primary" :loading="loading" @click="submitForm">
        Request revision
      </el-button>
    </template>
  </ModalLayout>
</template>

<script>
import ModalLayout from './ModalLayout.vue'

export default {
  name: 'RequestRevision',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        instructions: '',
      },
      rules: {
        instructions: [{ required: true, message: 'Revision Instructions are required', trigger: 'blur' }],
      },
    }
  },
  computed: {
    name() {
      return this.meta?.flight ? `${this.meta?.flight.name}` : this.meta?.campaign?.name
    },
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            await this.$store.dispatch('socialBoostCampaign/requestRevision', {
              campaign_id: this.meta?.id || this.$route.params.id,
              flight_id: this.meta?.flight_id || this.$route.params.flight_id,
              instructions: this.form.instructions,
            })
          } catch (e) {
            console.error(e)
          } finally {
            this.loading = false
            this.$store.dispatch('socialBoostCampaign/getCampaign', { id: this.meta?.id || this.$route.params.id })
            this.close()
          }
        } else {
          console.log('Form validation failed')
          return false
        }
      })
    },
  },
}
</script>
